import React from 'react';
import { renderContent, renderContentWithParams } from 'utilities/content/content-utilities';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import IconShoppingBasketAdd from '@tvg/fuse-icons/lib/ShoppingBasketAdd';
import IconPersonAuthenticate from '@tvg/fuse-icons/lib/PersonAuthenticate';
import IconAccountBalanceWallet from '@tvg/fuse-icons/lib/AccountBalanceWallet';
import IconDescription from '@tvg/fuse-icons/lib/Description';
import IconCalendarMonth from '@tvg/fuse-icons/lib/CalendarMonth';
import {
  DialogPanel,
  DialogSection,
  DialogSectionIcon,
  DialogSectionHeading,
  DialogSectionSubHeading,
  DialogList,
  DialogListItem,
  DialogText,
  AprSection,
  HowToUseSection,
  HowToUseList,
  HowToUseStep,
} from '../styles/VeryPayDialogStyles';

type Props = {
  active: boolean;
  apr: string;
  amount: string;
  percent: string;
  nonCreditAccountUser: boolean;
  transitionDuration: number;
};

function StcPage(props: Props) {
  const { active, apr, amount, percent, nonCreditAccountUser, transitionDuration } = props;

  return (
    <DialogPanel active={active} transitionDuration={transitionDuration} dataTestId="verypay_dialog_stc">
      <DialogSection>
        <DialogSectionIcon
          icon={<IconCalendarMonth />}
          width="32px"
          height="32px"
          alt={renderContent('verypay.dialog.stc.dialogHeading')}
        />
        <DialogSectionHeading tag="h3" size="4">
          {renderContent('verypay.dialog.stc.subHeading')}
        </DialogSectionHeading>
        <DialogSectionSubHeading tag="h4" size="4">
          {renderContent('verypay.dialog.stc.info.heading')}
        </DialogSectionSubHeading>

        <DialogList>
          <DialogListItem>{renderContent('verypay.dialog.stc.info.point1')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.stc.info.point2')}</DialogListItem>
          <DialogListItem data-testid="verypay_dialog_stc_attributes">
            {renderContentWithParams({
              id: 'verypay.dialog.stc.info.point3',
              params: [amount, percent],
            })}
          </DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.stc.info.point4')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.stc.info.point5')}</DialogListItem>
          <DialogListItem>{renderContent('verypay.dialog.stc.info.point6')}</DialogListItem>
        </DialogList>

        {apr && nonCreditAccountUser && (
          <AprSection>
            <TypographyElement tag="h3" size="m1">
              {renderContent('verypay.dialog.stc.representative.heading')}
            </TypographyElement>
            <DialogText>{renderContent('verypay.dialog.stc.representative.subtext1')}</DialogText>
            <TypographyElement tag="h3" size="m1">
              {renderContentWithParams({
                id: 'verypay.dialog.stc.representative.heading2',
                params: [apr],
              })}
            </TypographyElement>
            <DialogText
              dangerouslySetInnerHTML={{
                __html: renderContentWithParams({
                  id: 'verypay.dialog.stc.representative.subtext2',
                  params: [apr],
                }),
              }}
            />
            <DialogText
              dangerouslySetInnerHTML={{
                __html: renderContent('verypay.dialog.stc.representative.subtext3'),
              }}
            />
          </AprSection>
        )}
      </DialogSection>

      <HowToUseSection>
        <DialogSectionHeading tag="h4" size="4">
          {renderContent('verypay.dialog.stc.howToUse.heading')}
        </DialogSectionHeading>

        <HowToUseList>
          <HowToUseStep
            icon={<IconShoppingBasketAdd />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.stc.howToUse.step1.heading')}
            description={renderContent('verypay.dialog.stc.howToUse.step1.description')}
          />

          <HowToUseStep
            icon={<IconPersonAuthenticate />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.stc.howToUse.step2.heading')}
            description={renderContent('verypay.dialog.stc.howToUse.step2.description')}
          />

          <HowToUseStep
            icon={<IconAccountBalanceWallet />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.stc.howToUse.step3.heading')}
            description={renderContent('verypay.dialog.stc.howToUse.step3.description')}
          />

          <HowToUseStep
            icon={<IconDescription />}
            size="large"
            height="64px"
            width="64px"
            heading={renderContent('verypay.dialog.stc.howToUse.step4.heading')}
            description={renderContent('verypay.dialog.stc.howToUse.step4.description')}
          />
        </HowToUseList>
      </HowToUseSection>
    </DialogPanel>
  );
}

export default StcPage;
